module.exports = __webpack_public_path__ + "img/IEBNP-SA.81711407.png";